




















































































































































































import PopupSortPlan from '@/components/common/PopupSortPlan.vue';
import PageLoader from '@components/common/PageLoader.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    PageLoader,
    PopupSortPlan,
  },
})
export default class PopupConfirmMenu extends Vue {
  @Prop({
    default() {
      return [];
    },
  })
  public selectedMenus!: any[];

  @Prop({
    default() {
      return [];
    },
  })
  public menus!: any[];

  public menuSearchString: string = '';
  public filteredMenus: any[] | null = null;
  public tempSelectedMenus: any[] = [];
  public isLoading: boolean = false;

  public mounted() {
    this.tempSelectedMenus = [...this.selectedMenus];
  }

  get activeMenuList() {
    if (this.filteredMenus !== null) {
      return this.filteredMenus;
    }
    return this.menus;
  }

  get tempSelectedMenuIds() {
    return this.tempSelectedMenus.map((menu) => menu.id);
  }

  beforeOpen({ params }) {
    this.filteredMenus = null;
    this.menuSearchString = '';
    this.tempSelectedMenus = [...this.selectedMenus];
  }

  searchByName() {
    this.isLoading = true;
    if (!this.menuSearchString) {
      this.filteredMenus = null;
    } else {
      this.filteredMenus = this.menus.filter((menu) =>
        menu.name.toLowerCase().includes(this.menuSearchString.toLowerCase()),
      );
    }
    this.isLoading = false;
  }

  handleClickMenuCheckbox(event, menu) {
    if (event.target.checked) {
      const menuDto = {
        id: menu.id,
        order: this.tempSelectedMenus.length + 1,
        display: true,
        name: menu.name,
        plans: menu.plans.map((plan, index) => ({
          id: plan.id,
          order: index + 1,
          display: true,
          name: plan.name,
        })),
      };
      this.tempSelectedMenus.push(menuDto);
    } else {
      this.tempSelectedMenus = this.tempSelectedMenus.filter(
        (i) => i.id !== menu.id,
      );

      this.tempSelectedMenus = this.tempSelectedMenus.map((menu, index) => ({
        ...menu,
        order: index + 1,
      }));
    }
  }

  handleChangeMenuOrder(oldIndex, newIndex) {
    if (oldIndex === newIndex - 1) {
      return;
    }

    const movedMenu = this.tempSelectedMenus.splice(oldIndex, 1)[0];

    this.tempSelectedMenus.splice(newIndex - 1, 0, movedMenu);

    this.tempSelectedMenus = this.tempSelectedMenus.map((menu, index) => ({
      ...menu,
      order: index + 1,
    }));
  }

  setPlansForMenu({ menuId, plans }) {
    const updatedMenu = this.tempSelectedMenus.find(
      (menu) => menu.id == menuId,
    );
    updatedMenu.plans = plans.map((plan, index) => ({
      ...plan,
      order: index + 1,
    }));
  }

  get allSelected(): boolean {
    return this.activeMenuList.every((menu) =>
      this.tempSelectedMenuIds.includes(menu.id),
    );
  }

  handleToggleActiveAllMenu() {
    if (this.allSelected) {
      const activeIds = this.activeMenuList.map((menu) => menu.id);
      this.tempSelectedMenus = this.tempSelectedMenus.filter(
        (menu) => !activeIds.includes(menu.id),
      );
    } else {
      const existingIds = this.tempSelectedMenuIds;
      const newMenus = this.activeMenuList
        .filter((menu) => !existingIds.includes(menu.id))
        .map((menu) => ({
          id: menu.id,
          order: this.tempSelectedMenus.length + 1,
          display: true,
          name: menu.name,
          plans: menu.plans.map((plan, index) => ({
            id: plan.id,
            order: index + 1,
            display: true,
            name: plan.name,
          })),
        }));

      this.tempSelectedMenus.push(...newMenus);
    }

    this.tempSelectedMenus = this.tempSelectedMenus.map((menu, index) => ({
      ...menu,
      order: index + 1,
    }));
  }

  submit() {
    this.$emit('submit', this.tempSelectedMenus);
    this.$modal.hide('popup-confirm-menu');
  }

  cancel() {
    this.$modal.hide('popup-confirm-menu');
  }
}
